export const UTM_SOURCES = {
  facebook: "facebook",
  whatsapp: "whatsapp",
  linkedin: "linkedin",
  x: "x",
  copy: "copy_link",
} as const;

export type UtmSource = (typeof UTM_SOURCES)[keyof typeof UTM_SOURCES];

export function buildShareUrl(
  baseUrl: string,
  source: UtmSource,
  content?: string,
) {
  const url = new URL(baseUrl);
  url.searchParams.set("utm_source", source);
  url.searchParams.set("utm_medium", "social");
  url.searchParams.set("utm_campaign", "share");
  if (content) {
    url.searchParams.set("utm_content", content);
  }
  return url.toString();
}
